const breakpoints = {
  mobile: 768,
};

export default function checkWindowSize(): { [key: string]: boolean } {
  return {
    isMobile: window.innerWidth <= breakpoints.mobile,
  };
}
